<template lang="pug">
	div
		div
			p.module() Ingreso fijo
			input.value(v-model="presupuesto" placeholder="$0.00")
		div
			p.result() TOTAL DE INGRESOS MENSUALES:
			span.final ${{presupuesto | toCurrency}}
</template>

<script>
import { mapGetters } from 'vuex';
import { debug } from 'util';
export default {
  name: 'Presupuesto',
  components: {
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
	data(){
    return {
      presupuesto: null
		}
	},	
	methods:{
	}
}
</script>

<style scoped>
@import 'presupuesto1.scss';
</style>
